import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW4500Model } from '../kymw4500.model';

// レスポンス構造
export type GetFixFeatureForMasterInfoResponse = {
  FeatureCode: string;
  MediumType: string;
  MediumName: string;
  OrderCode: string;
  DelivCatalogId: string;
  FeatureName: string;
  ApprovalFlowType: number;
  ApprovalFlowTypeName: string;
  NotificationUserId: string;
  NotificationUserName: string;
  TagList:
  {
    TagId: string;
    TagName: string;
  }[];
  PayeeSupplierList:
  {
    PayeeSupplierCode: string;
    PayeeSupplierName: string;
  }[]
  PlannerSelectionFlag: string;
  AssociatedCompanyId: string;
  AssociatedCompanyName: string;
  Remarks: string;
  FeaturePerMediaFlag: string;
};

/**
 * 固定特集情報マスタ取得
 *
 * @export GetFixFeatureForMasterInfoService
 * @class GetFixFeatureForMasterInfoService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetFixFeatureForMasterInfoService extends PlessJsonResponderSub<GetFixFeatureForMasterInfoResponse[]> {
  private mediumType: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFixFeatureForMasterInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.mediumType
      },
    });
  }

  /**
   * API呼び出し
   * @param vo 
   * @param successFunc
   * @memberof GetFixFeatureForMasterInfoService
   */
  execute(model: KYMW4500Model, successFunc: Function = null): void {
    this.mediumType = model.mediumType;
    this.successFunc = successFunc;
    this.send('getFixFeatureForMasterInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFixFeatureForMasterInfoService
   */
  success(data: GetFixFeatureForMasterInfoResponse[]) {
    if (this.successFunc) this.successFunc(data);
  }
}
